export default function initEvents() {
  let yearValue = document.getElementById("year-value")

  if (yearValue !== null) {
    let thisWeekBtn = document.getElementById("this-week-btn")
    let mobileThisWeekBtn = document.getElementById("mobile-this-week-btn")
    const pastEventsElement = document.getElementById("events_show_past_events")
    const showPastEvents = pastEventsElement && pastEventsElement.length != 0 ? pastEventsElement.value : "0"

    if (thisWeekBtn) {
      thisWeekBtn.addEventListener("click", (event) => {
        event.target.classList.add("active-month")
        getThisWeekEvents()
      })
    }

    if (mobileThisWeekBtn) {
      mobileThisWeekBtn.addEventListener("click", (event) => {
        event.target.classList.add("active-month")
        getThisWeekEvents()
      })
    }

    const currentYearImmutable = new Date().getFullYear()
    let currentYear = new Date().getFullYear()
    let currentMonth = new Date().getMonth() + 1
    yearValue.innerHTML = currentYear
    let globalEvents = []
    const eventBlock = document.getElementById("event-block")

    let yearButtonMinus = document.querySelector(".year-btn[data-type='minus']")
    let yearButtonPlus = document.querySelector(".year-btn[data-type='plus']")

    if (showPastEvents === "0" && currentYear <= currentYearImmutable) {
      yearButtonMinus.classList.add("hidden")
    }
    yearButtonMinus.addEventListener("click", () => {
      currentYear -= 1
      yearValue.innerHTML = currentYear
      if (showPastEvents === "0" && currentYear <= currentYearImmutable) {
        yearButtonMinus.classList.add("hidden")
      }
      setMonthButtonClasses()
      getMonthlyEvents()
    })

    yearButtonPlus.addEventListener("click", () => {
      currentYear += 1
      yearValue.innerHTML = currentYear
      if (showPastEvents === "0" && currentYear > currentYearImmutable) {
        yearButtonMinus.classList.remove("hidden")
        const monthLists = document.getElementsByClassName("month-list")
        Array.from(monthLists).forEach(function (monthElement) {
          monthElement.classList.remove("hidden")
        })

        const mobileMonthLists = document.getElementsByClassName("mobile-month")
        Array.from(mobileMonthLists).forEach(function (monthElement) {
          monthElement.classList.remove("hidden")
        })
      }
      setMonthButtonClasses()
      getMonthlyEvents()
    })

    const monthButtons = document.querySelectorAll(".month-btn[data-month]")

    monthButtons.forEach((button) => {
      if (button.getAttribute("data-month") == currentMonth) {
        button.classList.add("active-month")
      }
      button.addEventListener("click", (event) => {
        currentMonth = event.target.getAttribute("data-month")
        removeActiveMonths()
        if (thisWeekBtn) {
          thisWeekBtn.classList.remove("active-month")
        }
        event.target.classList.add("active-month")
        getMonthlyEvents()
      })
    })

    const selectDropdown = document.querySelectorAll(".month-select")

    selectDropdown.forEach((select) => {
      select.addEventListener("change", (event) => {
        currentMonth = event.target.value
        if (currentMonth === "0") {
          getThisWeekEvents()
        } else {
          getMonthlyEvents()
        }
      })
    })

    async function getMonthlyEvents() {
      const URL = "/events/getEventsByMonth"
      let options = {
        year: currentYear,
        month: currentMonth,
      }
      try {
        const events = await axios.get(URL, { params: options }).then((response) => {
          return response.data
        })
        globalEvents = events
        generateHTML()
        return events
      } catch (err) {
        return []
      }
    }

    async function getThisWeekEvents() {
      const URL = "/events/getEventsNext7Days"
      try {
        const events = await axios.get(URL).then((response) => {
          return response.data
        })

        globalEvents = events

        if (thisWeekBtn) {
          thisWeekBtn.style.display = "none"
        }
        if (mobileThisWeekBtn) {
          mobileThisWeekBtn.style.display = "none"
        }
        if (events.length >= 1) {
          if (thisWeekBtn) {
            thisWeekBtn.style.display = "block"
          }
          if (mobileThisWeekBtn) {
            mobileThisWeekBtn.style.display = "block"
          }
          removeActiveMonths()
          if (thisWeekBtn) {
            thisWeekBtn.classList.add("active-month")
          }
          generateHTML()
        } else {
          getMonthlyEvents()
        }
        return events
      } catch (error) {
        return []
      }
    }

    function setMonthButtonClasses() {
      const currentYearImmutable = new Date().getFullYear()
      const currentMonthImmutable = new Date().getMonth() + 1
      const monthButtons = document.querySelectorAll(".month-btn[data-month]")
      monthButtons.forEach((button) => {
        button.classList.remove("past-month")
        if (yearValue.innerHTML == currentYearImmutable && button.getAttribute("data-month") < currentMonthImmutable) {
          button.classList.add("past-month")
          if (showPastEvents === "0") {
            button.closest(".month-list").classList.add("hidden")
          }
        }
        if (yearValue.innerHTML < currentYearImmutable) {
          button.classList.add("past-month")
        }
      })
      const mobileMonthButtons = document.querySelectorAll(".mobile-month")
      mobileMonthButtons.forEach((option) => {
        option.classList.remove("past-month")
        if (yearValue.innerHTML == currentYearImmutable && option.value < currentMonthImmutable) {
          option.classList.add("past-month")
          if (showPastEvents === "0") {
            option.classList.add("hidden")
          }
        }
        if (yearValue.innerHTML < currentYearImmutable) {
          option.classList.add("past-month")
        }
      })
    }

    function removeActiveMonths() {
      monthButtons.forEach((button) => {
        button.classList.remove("active-month")
      })
    }

    function generateHTML() {
      const eventContainer = document.getElementById("event-container")
      eventContainer.innerHTML = ""

      globalEvents.forEach((event) => {
        let newBlock = eventBlock.cloneNode(true)
        newBlock.classList.remove("hidden")
        const dateString = event.dates.join(", ")
        newBlock.querySelector("#event-date").innerHTML = dateString
        newBlock.querySelector("#event-title").innerHTML = event.base.title
        newBlock.querySelector("#event-text").innerHTML = event.text
        if (event.image) {
          newBlock.querySelector("#event-image").src = event.image.url
          newBlock.querySelector("#event-image").alt = event.image.source_media.alt
        }
        if (event.page_enabled === 1) {
          newBlock.querySelector("#event-full-details-button").href = event.base.url
          newBlock.querySelector("#event-full-details-button").classList.remove("hidden")
          newBlock.querySelector("#event-full-details-container").classList.remove("hidden")
        }
        eventContainer.appendChild(newBlock)
      })

      let emptyMessage = document.getElementById("events-no-events-message")
      if (globalEvents.length == 0) {
        emptyMessage.classList.remove("hidden")
      } else {
        emptyMessage.classList.add("hidden")
      }
    }

    getThisWeekEvents()
    setMonthButtonClasses()
  }
}
